import styled from "styled-components";

export const ExportButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const ExportLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--neutral-light);
  margin-right: 4px;
`;

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--lightest);
  border: 1px solid var(--gray-light);
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--primary);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--primary);
    color: var(--lightest);
    border-color: var(--primary);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
